import { Branding } from '../branding';

export const brandingValues = {
  branding: Branding.RIA,
  httpBrand: '0',
  css: '',
  segmentProduct: 'Ria',
  locale: '', // used in localization
  partnerName: 'Ria',
  logo: '',
};



// WEBPACK FOOTER //
// ./src/environment/branding/ria.ts